import { render } from "./GalleryPreview.vue?vue&type=template&id=6ffeda00&scoped=true"
import script from "./GalleryPreview.vue?vue&type=script&lang=js"
export * from "./GalleryPreview.vue?vue&type=script&lang=js"

import "./GalleryPreview.vue?vue&type=style&index=0&id=6ffeda00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ffeda00"]])

export default __exports__